import {
  ORDER_CREATE_REQUEST,
  ORDER_CREATE_SUCCESS,
  ORDER_CREATE_FAIL,
} from "../actions/orderActions";


const initialState = {
  loading: false,
  order: null,
  error: null,
  errorCode: null,
};


const orderReducer = (
  state = initialState,
  action
) => {

  switch (action.type) {

    case ORDER_CREATE_REQUEST:

      return {
        ...state,
        loading: true,
        error: null,
        errorCode: null,
      };


    case ORDER_CREATE_SUCCESS:

      return {
        ...state,
        loading: false,
        order: action.payload,
        error: null,
        errorCode: null,
      };


    case ORDER_CREATE_FAIL:

      return {
        ...state,
        loading: false,
        error:
          action.payload?.message ||
          action.payload,
        errorCode:
          action.payload?.code ||
          null,
      };


    default:

      return state;
  }
};


export default orderReducer;